import * as tslib_1 from "tslib";
// Core packages
import { OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { ToastrService } from "ngx-toastr";
import { finalize } from "rxjs/operators";
// Custom packages
import { AuthService } from "src/app/modules/auth/auth.service";
import { PermissionsService } from "src/app/modules/permissions/permissions.service";
import { UsersService } from "src/app/modules/users/users.service";
import { Role } from "src/app/shared/models/role/role.model";
import { ApiService } from "src/app/shared/services/api.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { HelperService } from "src/app/shared/services/helper.service";
import { ThemeService } from "src/app/shared/services/theme.service";
var AddRoleComponent = /** @class */ (function () {
    // END - Add role form
    /**
     * Class constructor
     */
    function AddRoleComponent(authService, helperService, configService, themeService, cookieService, translateService, usersService, router, toastrService, permissionsService, apiService) {
        this.authService = authService;
        this.helperService = helperService;
        this.configService = configService;
        this.themeService = themeService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.usersService = usersService;
        this.router = router;
        this.toastrService = toastrService;
        this.permissionsService = permissionsService;
        this.apiService = apiService;
        this.subscriptions = [];
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
        // BEGIN - Add role form
        // BEGIN - ngx-formly
        this.form = new FormGroup({});
        this.model = {};
        this.fields = [];
        this.options = {};
        // END - ngx-formly
        this.formBtnOptions = {
            active: false,
            text: this.translateService.instant("common.cta.save"),
            spinnerSize: 19,
            raised: true,
            stroked: true,
            flat: false,
            fab: false,
            buttonColor: "primary",
            spinnerColor: "primary",
            fullWidth: false,
            disabled: false,
            mode: "indeterminate",
            buttonIcon: {
                fontSet: "fal",
                fontIcon: "fa-save",
                inline: true,
            },
        };
    }
    /**
     * Init components
     *
     * @since 1.0.0
     */
    AddRoleComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Set page title
        this.themeService.setPageTitle(this.translateService.instant("roles.add.pageTitle"));
        // Get logged user data
        this.subscriptions.push(this.authService.loggedUser$.subscribe(function (res) { return (_this.loggedUser = res); }));
        // Get current lang
        this.lang =
            this.cookieService.get("lang") || this.configService.defaultLang;
        this.subscriptions.push(this.permissionsService.getList(0, -1, "", "").subscribe(function (res) {
            if (res.status) {
                // Init form
                _this.initForm(res.data.items);
                return;
            }
            // @todo translate
            _this.toastrService.error("Errore!", "Impossibile recuperare i permessi. Prova tra un attimo");
        }));
    };
    /**
     * Handle component destroy
     *
     * @since 1.0.0
     */
    AddRoleComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(function (sub) { return sub.unsubscribe(); });
    };
    /**
     * Group given 'arr' array by given 'prop' property value
     * and return the grouped array
     *
     * @since 1.0.0
     */
    AddRoleComponent.prototype.getGroups = function (arr, prop) {
        var map = new Map(Array.from(arr, function (obj) { return [obj[prop], []]; }));
        arr.forEach(function (obj) { return map.get(obj[prop]).push(obj); });
        return Array.from(map);
    };
    /**
     * Init form
     *
     * @since 1.0.0
     */
    AddRoleComponent.prototype.initForm = function (permissions) {
        var _this = this;
        // Set model
        this.model = new Role();
        // Build permissions' groups
        var groupedPermissions = this.getGroups(permissions, "module");
        var groups = [];
        groupedPermissions.forEach(function (permissionGroup) {
            var group = [];
            group.push({
                className: "col-12 min-height-auto",
                template: "\n          <div>\n            <strong>" + _this.translateService.instant("roles.fields.permissionsForModule", { module: permissionGroup[0] }) + ":</strong>\n          </div>\n          ",
            });
            permissionGroup[1].forEach(function (permission) {
                var items = {
                    className: "col-12 col-md-4",
                    key: "permissions[" + permissionGroup[0] + "][" + permission._id + "]",
                    fieldGroupClassName: "permission-wrapper",
                    fieldGroup: [
                        {
                            className: "col-12",
                            key: "_id",
                            type: "checkbox",
                            checked: false,
                            templateOptions: {
                                label: permission.name,
                                required: false,
                                checked: false,
                            },
                        },
                        {
                            className: "col-12",
                            key: "expiresAt",
                            type: "datepicker",
                            templateOptions: {
                                placeholder: "Scadenza permesso",
                                label: "Scadenza permesso",
                                min: new Date(),
                            },
                            hideExpression: function (model, formState) {
                                if (_this.model &&
                                    _this.model.permissions &&
                                    _this.model.permissions[permissionGroup[0]] &&
                                    _this.model.permissions[permissionGroup[0]][permission._id]._id) {
                                    return false;
                                }
                                return true;
                            },
                        },
                        {
                            className: "col-12",
                            key: "relatedObjId",
                            type: "input",
                            templateOptions: {
                                placeholder: "ID oggetto correlato",
                                label: "ID oggetto correlato",
                                min: new Date(),
                                required: false,
                            },
                            hideExpression: function (model, formState) {
                                if (_this.model &&
                                    _this.model.permissions &&
                                    _this.model.permissions[permissionGroup[0]] &&
                                    _this.model.permissions[permissionGroup[0]][permission._id]._id) {
                                    return false;
                                }
                                return true;
                            },
                        },
                        {
                            className: "col-12",
                            key: "relatedObjRef",
                            type: "select",
                            templateOptions: {
                                placeholder: "Referenza oggetto correlato",
                                label: "Referenza oggetto correlato",
                                required: false,
                                // @todo update this once web-app modules are complted
                                options: [
                                    {
                                        value: "User",
                                        label: "Utenti",
                                    },
                                    {
                                        value: "Permission",
                                        label: "Permessi",
                                    },
                                    {
                                        value: "Role",
                                        label: "Ruoli",
                                    },
                                    {
                                        value: "Company",
                                        label: "Società",
                                    },
                                    {
                                        value: "Property",
                                        label: "Immobili",
                                    },
                                    {
                                        value: "Supplier",
                                        label: "Fornitori",
                                    },
                                    {
                                        value: "Service",
                                        label: "Servizi",
                                    },
                                ],
                            },
                            hideExpression: function (model, formState) {
                                if (_this.model &&
                                    _this.model.permissions &&
                                    _this.model.permissions[permissionGroup[0]] &&
                                    _this.model.permissions[permissionGroup[0]][permission._id]._id) {
                                    return false;
                                }
                                return true;
                            },
                        },
                        {
                            className: "col-12",
                            key: "relatedObjSection",
                            type: "input",
                            templateOptions: {
                                placeholder: "Sezioni oggetto correlato",
                                label: "Sezioni oggetto correlato",
                                required: false,
                            },
                            hideExpression: function (model, formState) {
                                if (_this.model &&
                                    _this.model.permissions &&
                                    _this.model.permissions[permissionGroup[0]] &&
                                    _this.model.permissions[permissionGroup[0]][permission._id]._id) {
                                    return false;
                                }
                                return true;
                            },
                        },
                    ],
                };
                group.push(items);
            });
            groups.push.apply(groups, tslib_1.__spread(group));
        });
        // Set fields
        this.fields = tslib_1.__spread(this.fields, [
            {
                fieldGroupClassName: "row",
                fieldGroup: tslib_1.__spread([
                    {
                        className: "col-12 col-md-6",
                        type: "input",
                        key: "name",
                        templateOptions: {
                            label: this.translateService.instant("roles.fields.name"),
                            placeholder: this.translateService.instant("roles.fields.name"),
                            required: true,
                            minLength: 3,
                            maxLength: 50,
                        },
                    },
                    {
                        className: "col-12 col-md-6",
                        type: "select",
                        key: "type",
                        templateOptions: {
                            label: this.translateService.instant("roles.fields.type"),
                            placeholder: this.translateService.instant("roles.fields.type"),
                            required: true,
                            options: [
                                {
                                    value: "admin",
                                    label: "Admin",
                                },
                                {
                                    value: "operator",
                                    label: "Operatore",
                                },
                                {
                                    value: "master",
                                    label: "Master",
                                },
                                {
                                    value: "collaborator",
                                    label: "Collaboratore",
                                },
                                {
                                    value: "temporary",
                                    label: "Temporaneo",
                                },
                                {
                                    value: "user",
                                    label: "Utente",
                                },
                            ],
                        },
                    }
                ], groups, [
                    {
                        className: "col-12",
                        type: "textarea",
                        key: "description",
                        templateOptions: {
                            label: this.translateService.instant("roles.fields.description"),
                            placeholder: this.translateService.instant("roles.fields.description"),
                            maxLength: 500,
                            required: true,
                            rows: 2,
                        },
                        expressionProperties: {
                            "templateOptions.description": '(model[field.key]||"").length+"/" +field.templateOptions.maxLength',
                        },
                    },
                ]),
            },
        ]);
    };
    /**
     * Handle form submit
     *
     * @since 1.0.0
     */
    AddRoleComponent.prototype.onFormSubmit = function (model) {
        var _this = this;
        // Prevent invalid form submit
        if (this.form.invalid) {
            Object.keys(this.form.controls).forEach(function (key) {
                _this.form.controls[key].markAsTouched();
            });
            this.toastrService.error(this.translateService.instant("common.errors.form_is_invalid"));
            console.warn(this.form);
            console.warn(model);
            return;
        }
        // Activate submit button loading status
        this.formBtnOptions.active = true;
        this.subscriptions.push(this.usersService
            .create(model)
            .pipe(finalize(function () { return (_this.formBtnOptions.active = false); }))
            .subscribe(function (res) {
            if (res.status) {
                _this.toastrService.success(res.message);
                setTimeout(function () {
                    var lang = _this.translateService.currentLang;
                    _this.router.navigate([
                        lang,
                        "app",
                        "roles",
                        "detail",
                        res.data._id,
                    ]);
                }, _this.configService.redirectDelayAfterCreation);
                return;
            }
        }, function (err) {
            // Choose one of the following error handling method.
            // 1) First one show a message right under the form fields
            //    (if the form is properly setted)
            // 2) Second one is used to show a mat-error under each field
            //    in the dynamic form (is meant to be used only in dynamicForm)
            // 3) Third one show toastr notifications for each error
            // 4) Fourth one is used to show mat-error under each field
            //    in the ngx-formly form (is mean to be used only with ngx-formly)
            // this.helperService.handleFormError(form, err);
            // this.helperService.handleDynamicFormError(form, err);
            // this.helperService.handleError(err);
            _this.helperService.handleFormlyError(_this.form, err);
        }));
    };
    return AddRoleComponent;
}());
export { AddRoleComponent };
